module.exports =
  "-----BEGIN RSA PUBLIC KEY-----\nMIGJAoGBAJRy2zaJxptG4XJfyf7U+Yv3u5ClQ7HuVEcK6Ou5jJnZ/ICLcHoDMl2B\ngD6G/YpDi341//UAYYj+biJozXmWXmirSMfE6oFqsE6zqkeY1+6rENVgFjgDV1F+\nnwz5GKwjRDNNMHY7X0svDyZjqBx16QkJFY9fvg4XudwN80a6h9jhAgMBAAE=\n-----END RSA PUBLIC KEY-----";
